(() => {
  'use strict';

  const endpoint = '/apps/rush-gpt/track-ai-visit';
  const sources = [
    ['chatgpt.com', 'chatgpt'],
    ['chat.openai.com', 'chatgpt'],
    ['openai.com', 'chatgpt'],
    ['perplexity.ai', 'perplexity'],
    ['gemini.google.com', 'gemini'],
    ['claude.ai', 'claude'],
    ['copilot.microsoft.com', 'bing'],
    ['edgeservices.bing.com', 'bing'],
  ];

  const analyticsAllowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || privacy.analyticsProcessingAllowed();
  };

  const detectSource = () => {
    const explicit = new URLSearchParams(window.location.search)
      .get('utm_source')
      ?.toLowerCase();

    if (explicit) {
      const match = ['chatgpt', 'gemini', 'perplexity', 'claude', 'bing', 'copilot']
        .find((source) => explicit.includes(source));
      if (match) return match === 'copilot' ? 'bing' : match;
    }

    if (!document.referrer) return null;

    try {
      const hostname = new URL(document.referrer).hostname.toLowerCase();
      if (hostname === window.location.hostname) return null;
      const match = sources.find(([domain]) => hostname === domain || hostname.endsWith(`.${domain}`));
      return match ? match[1] : null;
    } catch (_error) {
      return null;
    }
  };

  const track = () => {
    if (!analyticsAllowed()) return;

    const source = detectSource();
    if (!source) return;

    const storageKey = `rushgpt_ai_tracked_${source}`;
    try {
      if (sessionStorage.getItem(storageKey)) return;
      sessionStorage.setItem(storageKey, '1');
    } catch (_error) {
      // Tracking can continue when session storage is unavailable.
    }

    const payload = JSON.stringify({
      botType: source,
      url: window.location.href,
      referrer: document.referrer || null,
      timestamp: new Date().toISOString(),
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(endpoint, new Blob([payload], { type: 'application/json' }));
      return;
    }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track, { once: true });
  } else {
    track();
  }
  document.addEventListener('visitorConsentCollected', track);
})();
